import type { EarlyPayoutActiveTab } from "./earlyPayoutTypes";

export const EARLY_PAYOUT_REPORTING_DOWNLOAD_FILENAME =
  "sportsbook-early-payout-reporting.csv";

// Reporting is a development-only tab gated by `useIsDevMode`; it is appended to
// EARLY_PAYOUT_TABS only inside dev/test environments.
export const EARLY_PAYOUT_REPORTING_TAB: {
  label: string;
  value: EarlyPayoutActiveTab;
} = { label: "Reporting", value: "reporting" };

export const EARLY_PAYOUT_REPORTING_TABLE_LABELS = {
  sport: "Sport",
  league: "League",
  market: "Market",
  matchup: "Matchup",
  timeOfWin: "Time of Win",
  scoreOnWin: "Score on Win",
  numberOfBets: "# of Bets",
  settledPayout: "Settled Payout",
} as const;
